import 'lenis/dist/lenis.css';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import Lenis from 'lenis';

let lenisInstance = null;

/**
 * Returns the active Lenis instance after init (for use in ported components).
 *
 * @return {Lenis|null}
 */
export function getLenis() {
	return lenisInstance;
}

/**
 * Avoid Lenis on wp-admin block/site/widget editors and inside iframes (e.g. preview canvas).
 *
 * @return {boolean}
 */
function shouldSkipSmoothScroll() {
	if ( typeof window === 'undefined' || typeof document === 'undefined' ) {
		return true;
	}
	if ( window.self !== window.top ) {
		return true;
	}
	if ( ! document.body ) {
		return false;
	}
	const c = document.body.classList;
	return (
		c.contains( 'block-editor-page' )
		|| c.contains( 'site-editor-php' )
		|| c.contains( 'widgets-php' )
	);
}

function initSmoothScroll() {
	if ( lenisInstance ) {
		return lenisInstance;
	}

	if ( shouldSkipSmoothScroll() ) {
		return null;
	}

	if ( 'scrollRestoration' in history ) {
		history.scrollRestoration = 'manual';
	}

	gsap.registerPlugin( ScrollTrigger );

	lenisInstance = new Lenis( {
		duration: 1.2,
		easing: ( t ) => Math.min( 1, 1.001 - Math.pow( 2, -10 * t ) ),
		orientation: 'vertical',
		gestureOrientation: 'vertical',
		smoothWheel: true,
		wheelMultiplier: 1,
		touchMultiplier: 2,
		infinite: false,
	} );

	lenisInstance.on( 'scroll', ScrollTrigger.update );

	gsap.ticker.add( ( time ) => {
		lenisInstance.raf( time * 1000 );
	} );

	gsap.ticker.lagSmoothing( 0 );

	if ( document.body ) {
		const ro = new ResizeObserver( () => {
			lenisInstance.resize();
			ScrollTrigger.refresh();
		} );
		ro.observe( document.body );
	}

	return lenisInstance;
}

if ( document.readyState === 'loading' ) {
	document.addEventListener( 'DOMContentLoaded', initSmoothScroll );
} else {
	initSmoothScroll();
}
